import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import TextHoverTooltip from './TextHoverTooltip';

/*
 * Aggrid custom renderer which expects a value of the form { text: string, isRejected: boolean }.
 * Will strike through the text if `isRejected`.
 */
export default function ArbitrageInscriptionCellRenderer({
    value,
}: CellRendererParams<
    unknown,
    {
        text: string;
        isRejected: boolean;
    }
>): React.ReactElement {
    // value will be empty when we group by another column, because we don't aggregate this column
    return value ? (
        <TextHoverTooltip
            value={value?.text}
            customStyle={{
                textDecoration: value?.isRejected ? 'line-through' : undefined,
                textAlign: 'right',
            }}
        />
    ) : (
        <> </>
    );
}
